import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";

@Component({ name: "CartPreview" })
export default class CartPreview extends Vue {
    public cartDetailInfo: any = null;

    get routes() {
        return (<any>window).App.routes;
    }

    get cart() {
        return this.$store.getters["cartStore/cart"]
    }

    get isCartPreviewShow() {
        return this.$store.getters["cartStore/isCartPreviewShow"];
    }

    public async created() {
        this.cartDetailInfo = (await Axios.post(this.routes.Cart_GetCartDetailInfo)).data;
    }

    public formatPrice(data: number) {
        return new Intl.NumberFormat('it-IT', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(data);
    }
};